try {
    document.addEventListener('DOMContentLoaded', function () {
        require('./init')
    })

    var Form = require('./form');
    var sitopCommentService = require('./sitopCommentService')
    var generalCommentService = require('./generalCommentService');
    var ExtensionService = require('live/services/extension')
    var ServiceLocator = require('live/services/service-locator').default

    const sitop = {
        name: 'SITOP',
        type: 'liverig-sitop',
        origin: 'Plugin Petrobras',
        roles: ['input'],
        icon: '/content/plugin-petrobras/sitop.png',
        ui: {
            form: Form,
            view: null
        }
    }

    ExtensionService.register(sitop)

    ServiceLocator.registerService('sitop-comment-service', sitopCommentService)
    ServiceLocator.registerService('general-comment-service', generalCommentService)
    ServiceLocator.getService('intervention-service').then(s =>
        s.dailyReportAdditionalControlsRegistry.register(require('./DailyReportSitopControl').DailyReportSitopControl)
    )
}
catch (e) {
    console.log(e);
}
